import { useEffect, useState, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import './NavbarStyles.css';
import { FaSearch } from "react-icons/fa";
import { SearchContext } from '../SearchContext'; // ✅ Import SearchContext

function NavbarComp() {
  const [opacity, setOpacity] = useState(1);
  const { setSearchTerm } = useContext(SearchContext); // ✅ Access setSearchTerm from context

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const newOpacity = Math.max(1 - scrollTop / 300, 0.85);
      setOpacity(newOpacity);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      variant="dark"
      className="custom-navbar"
      style={{
        top: 0,
        opacity: opacity,
        transition: 'opacity 0.3s ease',
      }}
    >
      <Container style={{ maxWidth: '1280px' }}>
        {/* Brand (visible on mobile only) */}
        <Navbar.Brand
          className="d-block d-lg-none"
          style={{
            color: '#fff',
            padding: '5px 10px',
            borderRadius: '4px',
            fontWeight: 'bold',
            fontSize: '15px',
          }}
        >
          HIDDEN TREASURE HERE
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll" className="w-100">
          {/* Left Menu */}
          <Nav className="me-auto my-2 my-lg-0" navbarScroll>
            <Nav.Link as={NavLink} to="/" end className="custom-link">
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/categories" className="custom-link">
              Categories
            </Nav.Link>
            <Nav.Link as={NavLink} to="/top-coupons" className="custom-link">
              Top Coupons
            </Nav.Link>
            <Nav.Link as={NavLink} to="/best-offers" className="custom-link">
              Best Offers
            </Nav.Link>
          </Nav>

          {/* Center Text (desktop only) */}
          <div className="d-none d-lg-flex align-items-center text-center center-title">
            HIDDEN TREASURE HERE
          </div>

          {/* Right Search (desktop only) */}
          <Form className="d-none d-lg-flex search-form">
            <Form.Control
              type="search"
              placeholder="Search for store, coupons & offers"
              className="search"
              aria-label="Search"
              onChange={(e) => setSearchTerm(e.target.value)} // ✅ Search handler
            />
            <button type="button" className="submit-btn">
              <FaSearch className="icon" />
            </button>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComp;
